const gameModes = {
  funFact: "fun-fact",
  slider: "slider",
  kahoot: "kahoot",
  sliderkahoot: "sliderkahoot",
  placeMarker: "placeMarker",
};

export default gameModes;
